import { getTime } from 'date-fns'
import { Action } from '../../actions/synchronize'
import { AuthorizationActions } from '../userAccount/actionNames'
import { SynchronizeActions } from './actionNames'
import initialStore from './initialStore'

export default function(
  store: Readonly<ISynchronizeStore> = initialStore,
  action: Action & any,
) {
  switch (action.type) {
    case SynchronizeActions.StartSync:
      return { ...store, isSynchronizing: true }
    case SynchronizeActions.SyncCompleted:
      return {
        ...store,
        isSynchronizing: false,
        lastDateSync: getTime(action.lastModifyDate),
        syncCount: store.syncCount + 1,
      }
    case SynchronizeActions.SetSyncDate:
      return { ...store, lastDateSync: getTime(action.lastModifyDate) }
    case SynchronizeActions.SyncRejected:
      return { ...store, isSynchronizing: false }
    case SynchronizeActions.ToggleNewVersionModal:
      return { ...store, newVersion: true, version: action.version }
    case SynchronizeActions.RequestSync:
      return { ...store, isSynchronizing: true }
    case SynchronizeActions.FetchConsecutiveErrors:
      return { ...store, hasCriticalError: true }
    case AuthorizationActions.FlushState:
      return { ...initialStore }
  }

  return store
}

export interface ISynchronizeStore {
  isSynchronizing: boolean
  lastDateSync: number
  newVersion: boolean
  version: string
  syncCount: number
  hasCriticalError: boolean
}
